import type { ShapeId } from './logic'

/** Набор простых фигур. Никакого текста - игра не зависит от языка. */
const PATHS: Readonly<Record<ShapeId, string>> = {
  circle: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Z',
  square: 'M4 4h16v16H4Z',
  triangle: 'M12 3 21.5 20H2.5Z',
  diamond: 'M12 2.5 21.5 12 12 21.5 2.5 12Z',
  star: 'M12 2.5l2.9 6.2 6.6.8-4.9 4.6 1.3 6.6L12 17.5 6.1 20.7l1.3-6.6L2.5 9.5l6.6-.8Z',
  hexagon: 'M7.5 3.5h9L21 12l-4.5 8.5h-9L3 12Z',
  cross: 'M9.4 3h5.2v6.4H21v5.2h-6.4V21H9.4v-6.4H3V9.4h6.4Z',
  ring: 'M12 3a9 9 0 1 0 0 18 9 9 0 0 0 0-18Zm0 4.6a4.4 4.4 0 1 1 0 8.8 4.4 4.4 0 0 1 0-8.8Z',
  arrow: 'M12 2.5 20 12h-4.6v9.5H8.6V12H4Z',
  moon: 'M16.5 12a9 9 0 0 1-9.6 9A9 9 0 0 0 6.9 3a9 9 0 0 1 9.6 9Z',
}

export function Shape({ id }: { id: ShapeId }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d={PATHS[id]} fill="currentColor" fillRule="evenodd" />
    </svg>
  )
}
